import classNames from 'clsx';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import { Checkbox, Tooltip } from '@swf/poker';

import {
  TXTWCL_Enables_webcam_functionalityX,
  TXTWCL_Webcam_game
} from './VideoChatToggle.messages.json';
import styles from './VideoChatToggle.scss';

interface Props {
  checked: boolean;
  supported: boolean;
  onChange: () => void;
  className?: string;
}

const VideoChatToggle = ({ className, checked, supported, onChange }: Props) => (
  <div className={classNames(styles.outer, className)}>
    <div className={styles.container}>
      <Tooltip
        arrowClassName={styles.tooltipArrow}
        tooltipClassName={styles.tooltip}
        content="Video chat is currently supported for 6 and 9 player Hold'em." // TODO: Translation
        hideTooltip={supported}
        placement="top"
      >
        <Checkbox
          checked={checked}
          disabled={!supported}
          id="enableVideoChat"
          onChange={onChange}
          label={
            <div>
              <Translation tagName="b" {...TXTWCL_Webcam_game} />
              <Translation tagName="p" {...TXTWCL_Enables_webcam_functionalityX} />
            </div>
          }
        />
      </Tooltip>
    </div>
  </div>
);

export default VideoChatToggle;
